export const updateCheckPointIds = (
  checkpointIds: string[],
  id: string
): string[] => {
  if (checkpointIds.includes(id)) {
    return checkpointIds.filter((checkpointId) => checkpointId !== id)
  } else {
    return [...checkpointIds, id]
  }
}

export const areCheckpointsUpdated = (
  orginal: string[],
  updated: string[]
): boolean => {
  return !(
    orginal?.every((id) => updated?.includes(id)) &&
    orginal?.length == updated?.length
  )
}
